import { ExamDto } from "@common/ict/model/interface/exam";
import { AxiosInstance } from "axios";
export class ICTExamApi {
  // 查询考试详情

  static queryExam(request: AxiosInstance, data: { evaluationPlanId: string }) {
    return request
      .get(`/service-exam/v1.0/evaluation_plans/details`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }

  // 查询试卷详情

  static queryTestPaper(
    request: AxiosInstance,
    data: { proposalPlanId: string }
  ) {
    return request
      .get(`/service-exam/proposalPlan/search`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }

  // 开始考试

  static startExam(request: AxiosInstance, data: { code: string; id: string }) {
    return request
      .post(`/service-exam/studentTask/start/exam`, data)
      .then(res => {
        return res;
      });
  }

  // 查询考试下面的试卷id
  static ExamCorrelationTestPaperId(
    request: AxiosInstance,
    data: { evaluationPlanId: string }
  ) {
    return request
      .get(`/service-exam/v1.0/implement_plan/proposalPlanid`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }

  // 提交行为
  static submitBehavior(
    request: AxiosInstance,
    data: {
      studentTaskId: string;
      paperId: string;
      implementId: string;
      behaviorType: string;
      behaviorDesc: string;
      result?: string;
    }
  ) {
    return request
      .post(`/service-exam/studentTask/exam/behavior`, data)
      .then(res => {
        return res;
      });
  }

  // 提交试题
  static submitQuestion(
    request: AxiosInstance,
    data: {
      studentTaskId: string;
      paperId: string;
      implementId: string;
      questionId: string;
      answer: string;
    }
  ) {
    return request
      .post(`/service-exam/studentTask/save/answer`, data)
      .then(res => {
        return res;
      });
  }

  // 查询考试记录
  static queryExamRecord(
    request: AxiosInstance,
    data: { implementId: string }
  ) {
    return request
      .get(`/service-exam/studentTask/select/exam`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }

  // 获取考试详情页2.0
  static getExamDatile(
    request: AxiosInstance,
    data: {
      evaluationPlanId: string,
      trainingPlanId: string
    }
  ) {
    return request
      .get(`/service-exam/v1.0/evaluation_plans/evaluationPlandetails`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }

  // 组卷页面
  static commandBuildPaper(
    request: AxiosInstance,
    data: {
      optionRadom: string;
      proposalPlanId: string;
      questionRadom: string;
    }
  ) {
    return request
      .post(`/service-exam/paper/v2.0/command/buildPaper`, data)
      .then(res => {
        return res;
      });
  }

  // 获取考试记录
  static getExamRecord(
    request: AxiosInstance,
    data: {
      implementId: string;
    }
  ) {
    return request
      .get(`/service-exam/studentTask/select/exam`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }
  // 获取考题信息接口
  static getExamInfo(
    request: AxiosInstance,
    data: {
      proposalPlanIds: string;
    }
  ) {
    return request
      .get(`/service-exam/proposalPlan/v2.0/getplanquestionbasebyids`, {
        params: data
      })
      .then(res => {
        return res;
      });
  }
  // 结束考试
  static endExamApi(request, query) {
    return request({
      url: `/service-exam/studentTask/end/exam`,
      method: "POST",
      params: query
    }).then(res => {
      return res;
    });
  }

  // 获取考试记录详情
  static getExamRecordDetail(request, query: { taskId: string }) {
    return request({
      url: `/service-exam/studentTask/getExam`,
      method: "GET",
      params: query
    }).then(res => {
      return res;
    });
  }
  // (前台)考试结束页
  static getExamTask(request, query: { taskId: string }) {
    return request({
      url: `/service-exam/studentTask/getExamTask`,
      method: "GET",
      params: query
    }).then(res => {
      return res;
    });
  }
  // 获取考试信息
  static GetBizClassExams(request: AxiosInstance, data: ExamDto) {
    return request.get(`/service-exam/v1.0/evaluation_plans/MyEvaluationPlan`, {
      params: data
    });
  }
  // 考试统计
  static examCollectCourse(request, query) {
    return request({
      url: `service-statistics/data/collect`,
      method: "POST",
      data: query
    }).then(res => {
      return res;
    });
  }
}
